import { localizeHref } from '@/paraglide/runtime';
import appleOriginalSvg from '@listening/assets/astro/images/Apple---Original.svg';
import capa1Svg from '@listening/assets/astro/images/Capa_1.svg';
import chromeSvg from '@listening/assets/astro/images/Chrome.svg';
import globalizationSvg from '@listening/assets/astro/images/Globalization.svg';
import readerChapters3xPng from '@listening/assets/astro/images/reader---chapters3x.png';

export function WorldClassListeningSection({
  showImage = true,
}: {
  showImage?: boolean;
}) {
  return (
    <section className='flex flex-col items-center justify-center px-5 py-8 sm:p-14 lg:p-18'>
      <div className='flex max-w-[1296px] flex-col items-center'>
        <div className='flex flex-col gap-8 px-5 pt-14 pb-8 sm:px-0 sm:py-14'>
          <h2 className='text-center text-[32px] leading-[34px] font-[700] text-neutral-945 sm:text-[40px] sm:leading-[43px] lg:text-[44px] lg:leading-[47px]'>
            A world class{' '}
            <span className='text-[32px] text-azure-595 sm:text-[44px]'>
              listening experience
            </span>{' '}
            on any device
          </h2>
          <div className='flex w-full flex-wrap items-center justify-center gap-6 lg:flex-nowrap'>
            <a
              className='flex w-auto max-w-full min-w-[180px] flex-[0_auto] items-center justify-center gap-3 rounded-full border border-solid border-neutral-210 p-3 no-underline sm:w-2/5 sm:p-4 lg:w-auto lg:min-w-[auto] lg:flex-1'
              href='https://apps.apple.com/us/app/listening-read-on-the-go/id1635430768'
            >
              <img alt='iOS download' loading='lazy' src={appleOriginalSvg} />
              <div className='text-[16px] leading-[28px] font-[500] text-neutral-700 no-underline sm:text-[18px]'>
                IOS
              </div>
            </a>
            <a
              className='flex w-auto max-w-full min-w-[180px] flex-[0_auto] items-center justify-center gap-3 rounded-full border border-solid border-neutral-210 p-3 no-underline sm:w-2/5 sm:p-4 lg:w-auto lg:min-w-[auto] lg:flex-1'
              href={localizeHref('/app/continue')}
            >
              <img alt='Web login' loading='lazy' src={globalizationSvg} />
              <div className='text-[16px] leading-[28px] font-[500] text-neutral-700 no-underline sm:text-[18px]'>
                Web
              </div>
            </a>
            <a
              className='flex w-auto max-w-full min-w-[180px] flex-[0_auto] items-center justify-center gap-3 rounded-full border border-solid border-neutral-210 p-3 no-underline sm:w-2/5 sm:p-4 lg:w-auto lg:min-w-[auto] lg:flex-1'
              href='https://chromewebstore.google.com/detail/listeningcom/amjjglmomeodglgclcnjdjbhhcfnbnpd'
            >
              <img alt='Chrome extension' loading='lazy' src={chromeSvg} />
              <div className='text-[16px] leading-[28px] font-[500] text-neutral-700 no-underline sm:text-[18px]'>
                Chrome App
              </div>
            </a>
            <a
              className='flex w-auto max-w-full min-w-[180px] flex-[0_auto] items-center justify-center gap-3 rounded-full border border-solid border-neutral-210 p-3 no-underline sm:w-2/5 sm:p-4 lg:w-auto lg:min-w-[auto] lg:flex-1'
              href='https://play.google.com/store/apps/details?id=io.listening.main&hl=en&gl=US'
            >
              <img alt='Android download' loading='lazy' src={capa1Svg} />
              <div className='text-[16px] leading-[28px] font-[500] text-neutral-700 no-underline sm:text-[18px]'>
                Android
              </div>
            </a>
          </div>
        </div>
        {showImage && (
          <div className='flex items-end overflow-hidden rounded-[24px] bg-cloud-750/75 bg-clip-border md:rounded-[48px]'>
            <img
              alt='Reader chapters interface'
              className='rounded-t-[24px] px-[16px] pt-[16px] md:rounded-t-[48px] md:px-[32px] md:pt-[32px]'
              loading='eager'
              src={readerChapters3xPng}
              width='1848'
            />
          </div>
        )}
      </div>
    </section>
  );
}
